import React, { useEffect, useState } from "react";
import "./Sidebar.css";
import { Link } from "react-router-dom";
import { useSubscriptions } from "../../pages/Subscriptions/fetchApi";
import { useAuth } from "../../pages/Login/connectApi/auth";

function Sidebar() {
  const [activeMenuId, setActiveMenuId] = useState(0);
  const [activeSubMenuId, setActiveSubMenuId] = useState(0);
  const [userTypeCode, setUserTypeCode] = useState(0);
  const { getUserInit } = useSubscriptions((state) => state.actions)
  const userInit = useSubscriptions((state) => state.userInit)
  const userSideBarAccess = useAuth((state) => state.userSideBarAccess)
  const { getUserLogin } = useAuth((state) => state.actions)
  useEffect(() => {
    getUserInit(localStorage.getItem("pelakUserId"))
    getUserLogin()
  }, [])


  useEffect(() => {
    setUserTypeCode(userInit?.userTypeCode)
  }, [userInit])


  const menuItems = [
    {
      id: 9,
      titlle: "بلاگ ها",
      href: "/Blogs",
      canAccess: userSideBarAccess?.canAccessBlog,
    },
    {
      id: 10,
      titlle: "اشتراک ها",
      href: "/Subscriptions",
      canAccess: userSideBarAccess?.canAccessSubscriptions,
    },
    {
      id: 1,
      titlle: "مدیریت شهر و استان",
      href: "/CityProvinceManagement",
      canAccess: userSideBarAccess?.canAccessCityState
    },/* budesh*/
    {
      id: 2,
      titlle: "کاربران",
      canAccess: userSideBarAccess?.canAccessUsers,
      subs: [
        { id: 1, title: "ایجاد کاربر", href: "/createNewUser", canAccess: userSideBarAccess?.canAccessCreateUser },
        { id: 2, title: "لیست کاربران", href: "/usersList", canAccess: userSideBarAccess?.canAccessUsersList },



      ],
    },/* budesh*/

    {
      id: 3,
      titlle: "تراکنش ها",
      href: "/transactions",
      canAccess: userSideBarAccess?.canAccessTransactions,

    },/* budesh*/
    {
      id: 4,
      titlle: "آگهی ها",
      canAccess: userSideBarAccess?.canAccessAds,
      subs: [
        // { id: 1, title: "ایجاد آگهی", href: "/amlak" },
        { id: 1, title: " ایجاد آگهی", href: "/CreateAd", canAccess: userSideBarAccess?.canAccessCreateAds },
        { id: 2, title: "لیست آگهی ها", href: "/productsList", canAccess: userSideBarAccess?.canAccessAdsList },
        // { id: 4, title: "   	لیست آگهی های ناقص", href: "/productsList/incomplete" },
        // { id: 3, title: "اعتبار آگهی", href: "/adValidity", canAccess: userSideBarAccess?.canAccessAdsValidity },
      ],
    },/* budesh*/
    {
      id: 5,
      titlle: "مرکز تماس ها",
      canAccess: userSideBarAccess?.canAccessMesageCenter,


      
      subs: [
        { id: 1, title: "پشتیبانی", href: "/support", canAccess: userSideBarAccess?.canAccessSupport },
        // { id: 2, title: "درخواست ها", href: "/request", canAccess: userSideBarAccess?.canAccessMesageCenter },
        { id: 3, title: "لیست پیام ها", href: "/msgList", canAccess: userSideBarAccess?.canAccessMessages },
        { id: 4, title: "گزارش شده ها", href: "/report", canAccess: userSideBarAccess?.canAccessReports },
        // { id: 5, title: "پیشنهادات و انتقادات", href: "/suggest" },
        { id: 6, title: "پیام خودکار", href: "/automaticMsg", canAccess: userSideBarAccess?.canAccessAutomaticMessages },
        { id: 7, title: "ارسال پیام گروهی", href: "/sendGroupMsg", canAccess: userSideBarAccess?.canAccessBulkMessages },
        { id: 8, title: "تنظیمات پیام ها", href: "/msgSetting", canAccess: userSideBarAccess?.canAccessMessagesOptions },
      ],
    },/* budesh*/
    {
      id: 6,
      titlle: "مانیتورینگ",
      canAccess: userSideBarAccess?.canAccessMonitoring,
      href: "/",
    },/* budesh*/
    {
      id: 8,
      titlle: "مدیریت تعرفه ها",
      canAccess: userSideBarAccess?.canAccessTariffManagement,
      subs: [
        { id: 1, title: "  تخفیفات و امتیازات", href: "/slide", canAccess: userSideBarAccess?.canAccessDiscountsAndScores },
        { id: 2, title: " قیمت ", href: "/priceManaging", canAccess: userSideBarAccess?.canAccessPrices },
        { id: 3, title: "   جایزه ها  ", href: "/category", canAccess: userSideBarAccess?.canAccessPrize },
      ],

    },
    {
      id: 10,
      titlle: "وکلای پلاک من",
      canAccess: userSideBarAccess?.canAccessTariffManagement,
      subs: [
        { id: 1, title: "صفحه اصلی", href: "/LawyersMain", canAccess: userSideBarAccess?.canAccessDiscountsAndScores },
        { id: 2, title: " دسته‌بندی‌ها ", href: "/LawyersCategory", canAccess: userSideBarAccess?.canAccessPrices },
        { id: 3, title: "فایل‌ها ", href: "/LawyersCategoryFile", canAccess: userSideBarAccess?.canAccessPrize },
        { id: 4, title: " وکلا ", href: "/Lawyer", canAccess: userSideBarAccess?.canAccessPrize },
        { id: 5, title: " هزینه مشاوره ", href: "/ConsultationDuration", canAccess: userSideBarAccess?.canAccessPrize },
      ],

    },


    // {
    //   id: 11,
    //   titlle: "   مدیریت محتوا" ,
    //   href: "/ContentManagement",
    // },
    {
      id: 15,
      titlle: "مدیریت محتوا",
      canAccess: userSideBarAccess?.canAccessContentManagement,
      subs: [
        { id: 1, title: "مدیریت اسلاید ها", href: "/slide", canAccess: userSideBarAccess?.canAccessSlides },
        { id: 2, title: " قوانین و مقررات", href: "/rules", canAccess: userSideBarAccess?.canAcceessRules },
        // { id: 3, title: " مدیریت دسته بندی ها ", href: "/category" },
        { id: 4, title: " مدیریت کادر های پیام ", href: "/modals", canAccess: userSideBarAccess?.canAccessAlerts },
        { id: 5, title: "درباره ما", href: "/aboutUs", canAccess: userSideBarAccess?.canAccessAbout },
      ],

    },/* budesh*/
    {
      id: 12,
      titlle: "  مشاورین املاک",
      canAccess: userSideBarAccess?.canAccessRealEstateAgents,
      href: "/RealEstateConsultants",
    },
    {
      id: 13,
      titlle: " آژانس املاک",
      canAccess: userSideBarAccess?.canAccessRealEstateAgencies,
      href: "/RealEstateAgency",
    },
    {
      id: 14,
      titlle: " سازندگان",
      canAccess: userSideBarAccess?.canAccessConstructors,
      href: "/Manufactureres",
    },
  ];


  return (
    <>
      <div className="area">

        <div className="login-modal-content2  bg-[#8B8B8B] ">
          <div className=" w-full h-screen p-4 text-white overflow-y-scroll">
            <ul className="flex flex-col gap-4 ">
              {

                menuItems
                  .filter((item) => item.canAccess === true)
                  .map((item) => (

                    <>
                      {
                        item.subs ? (
                          <>
                            {item.subs ? (
                              <span
                                onClick={() => setActiveMenuId(item.id)}
                                className={`mt-4 text-xl ${item.id === activeMenuId
                                  ? "text-[#EBFF00]"
                                  : "text-white"
                                  }  flex items-center justify-between cursor-pointer`}
                              >
                                <span>{item.titlle}</span>
                                <img
                                  src="/icons/arrow.svg"
                                  alt="active-icon"
                                  className={`transition-all ${item.id === activeMenuId ? "-rotate-90" : ""
                                    }`}
                                />
                              </span>
                            ) : (
                              ""
                            )}
                          </>
                        ) : (
                          <Link
                            to={item.href}
                            onClick={() => setActiveMenuId(item.id)}
                            className={`mt-4 text-xl ${item.id === activeMenuId ? "text-[#EBFF00]" : "text-white"
                              }  flex items-center justify-between cursor-pointer`}
                          >
                            <span>{item.titlle}</span>
                          </Link>
                        )}
                      {item.subs && activeMenuId === item.id
                        ? item.subs
                          .filter((sub) => sub.canAccess === true)
                          .map((sub) => (
                            <ul className="flex flex-col gap-2 ">
                              <Link
                                onClick={() => setActiveSubMenuId(sub.id)}
                                to={sub.href}
                                className="relative flex items-center cursor-pointer"
                              >
                                <span className="mr-[15px]">{sub.title}</span>
                                {sub.id === activeSubMenuId ? (
                                  <img
                                    src="/icons/menu-active.svg"
                                    alt="active-icon"
                                    className="absolute	-right-4"
                                  />
                                ) : (
                                  ""
                                )}
                              </Link>
                            </ul>
                          ))
                        : ""}
                    </>
                  ))

              }


            </ul>
          </div>
        </div>
        <ul className="circles">
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
      </div>
    </>
  );
}

export default Sidebar;
